import { render, staticRenderFns } from "./MarketingMaster.vue?vue&type=template&id=c60fe4d2&"
import script from "./MarketingMaster.vue?vue&type=script&lang=js&"
export * from "./MarketingMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports